export default {
  /**
   * @desc页面数据
   */
  state: {
    management: [{
      src:'/static/management/management1.png',
      name: '进货记录',
    }, {
      src:'/static/management/management2.png',
      name: '出货记录',
    }, {
      src:'/static/management/management3.png',
      name: '库存记录',
    }, {
      src:'/static/management/management4.png',
      name: '每日晨检',
    }, {
      src:'/static/management/management5.png',
      name: '清洗消毒',
    }, {
      src:'/static/management/management6.png',
      name: '五病调离',
    }, {
      src:'/static/management/management7.png',
      name: '食品留样',
    }, {
      src:'/static/management/management8.png',
      name: '废弃物管理',
    } ,{
      src:'/static/management/management9.png',
      name: '进货记录',
    }],
    other: [{
      src:'/static/index/Management.png',
      name: '规范经营',
    }, {
      src:'/static/index/Video.png',
      name: '视频查看',
    },{
      src:'/static/index/Archives.png',
      name: '档案管理',
    },{
      src:'/static/index/Employees.png',
      name: '从业人员',
    },{
      src:'/static/index/Notice.png',
      name: '通知公告',
    },{
      src:'/static/index/Supervisor.png',
      name: '监管人员',
    },{
      src:'/static/index/Law.png',
      name: '法律法规',
    },{
      src:'/static/index/Allocation.png',
      name: '台账配置',
    },{
      src:'/static/index/Guide.png',
      name: '办事指南',
    },{
      src:'/static/index/Information.png',
      name: '行业资讯',
    },{
      src:'/static/index/User.png',
      name:'个人中心',
    }],
    ledger:[{
      src:'/static/ledger/category.png',
      name:'食品类别',
    },{
      src:'/static/ledger/name.png',
      name:'食品名称',
    },{
      src:'/static/ledger/management.png',
      name:'管理人员',
    },{
      src:'/static/ledger/equipment.png',
      name:'场所设备',
    },{
      src:'/static/ledger/Supplier.png',
      name:'供应商',
    }] 
    
  }
}



// WEBPACK FOOTER //
// ./src/store/management.js